@if (useLazyLoad || isLoaded) {
  <wc-wrapper [contentWrapper]="wrapper">
    <sd-push-panel #pushPanel
      sd-component-wrapper-component
      (clicked)="onClick($event)"
      [sdSpyTarget]="componentUid"
      [pushFullHeight]="pushFullHeight"
      [pushTop]="pushTop"
      [pushBottom]="pushBottom"
      [layout]="layout"
      [twicPicsAutoSize]="!isFirst"
      [brand]="brandCorner"
      [isLoading]="useLazyLoad && !isLoaded"
      (cardClicked)="onCardPushClick($event)"
    />
  </wc-wrapper>
}
